<template>
  <div class="orders-by-status-chart">
    <apexchart
      type="bar"
      height="350"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'OrdersByStatusChart',
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  computed: {
    chartOptions() {
      return {
        chart: {
          type: 'bar',
          height: 350,
        },
        plotOptions: {
          bar: {
            horizontal: true,
            distributed: true,
          },
        },
        dataLabels: {
          enabled: true,
        },
        colors: [
          '#3c58e7',
          '#f5c826',
          '#5cb85c',
          '#d9534f',
          '#5c11a2',
          '#f54526',
        ],
        xaxis: {
          categories: this.categories,
        },
        yaxis: {
          title: {
            text: 'Status',
          },
        },
        legend: {
          show: false,
        },
        tooltip: {
          y: {
            formatter: (val) => {
              return val + ' orders'
            },
          },
        },
      }
    },
    categories() {
      return _.map(this.data, (d) => d._id || 'Unknown')
    },
    series() {
      const values = _.map(this.data, (d) => d.count)
      return [
        {
          name: 'Orders',
          data: values,
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped></style>



